const translations = {
  pl: {
    // Navigation
    dashboard: 'Panel główny',
    contractors: 'Kontrahenci',
    suppliers: 'Dostawcy',
    admin: 'Admin',
    inbox: 'Skrzynka',
    negotiations: 'Negocjacje',
    reports: 'Raporty',
    emailDrafts: 'Emaile',
    phoneCalls: 'Telefony',
    agentConfig: 'Profil Agenta',
    agentRoles: 'Role i Obowi\u0105zki',
    settings: 'Ustawienia',
    research: 'Wywiad o kontrahentach',
    products: 'Katalog produktów',
    visualMatch: 'Rozpoznaj ze zdjęcia',
    documents: 'Dokumenty',
    pipeline: 'Pipeline sprzedażowy',
    strategy: 'Planer strategii',
    merchant: 'Autonomiczny Handlowiec',
    projectAnalyzer: 'Analizator projektow',
    leadQueue: 'Kolejka leadow',
    offerCreator: 'Kreator Ofert',
    intelligence: 'Centrum Wywiadowcze',
    architects: 'Architekci',
    proposals: 'Oferty i Umowy',
    meetings: 'Spotkania',
    genome: 'Domain Genome',
    recommendations: 'Rekomendacje AI',
    tenders: 'Przetargi',
    preTender: 'Pre-Tender (sygnały)',
    feed: 'Feed Adama',
    subscriptions: 'Subskrypcje',
    homeV3: 'Home (briefing)',

    // Dashboard
    activeNegotiations: 'Aktywne negocjacje',
    atRiskNegotiations: 'Zagrożone',
    totalContractors: 'Kontrahenci',
    avgReputation: 'Śr. reputacja',
    totalReports: 'Raporty',
    recentActivity: 'Ostatnia aktywność',

    // Contractors
    addContractor: 'Dodaj kontrahenta',
    name: 'Nazwa',
    company: 'Firma',
    email: 'Email',
    phone: 'Telefon',
    notes: 'Notatki',
    tags: 'Tagi',
    reputation: 'Reputacja',
    lastInteraction: 'Ostatnia interakcja',
    riskLevel: 'Poziom ryzyka',
    delete: 'Usuń',
    edit: 'Edytuj',
    save: 'Zapisz',
    cancel: 'Anuluj',
    
    // Negotiations
    newNegotiation: 'Nowa negocjacja',
    brief: 'Zlecenie',
    channel: 'Kanał',
    chat: 'Czat',
    status: 'Status',
    active: 'Aktywna',
    completed: 'Zakończona',
    sendMessage: 'Wyślij wiadomość',
    typeMessage: 'Wpisz wiadomość kontrahenta...',
    generateReport: 'Generuj raport',
    generateEmail: 'Generuj email',
    
    // Agent Config
    agentName: 'Imię agenta',
    experience: 'Doświadczenie',
    origin: 'Pochodzenie',
    defaultStyle: 'Styl domyślny',
    superpower: 'Super-moc',
    weakness: 'Słabość',
    beliefs: 'Przekonania',
    addBelief: 'Dodaj przekonanie',
    language: 'Język',
    
    // Internal State
    impatience: 'Zniecierpliwienie',
    curiosity: 'Zaciekawienie',
    distance: 'Dystans',
    satisfaction: 'Satysfakcja',
    internalState: 'Stan wewnętrzny',
    
    // Profile
    negotiationStyle: 'Styl negocjacji',
    knowledgeLevel: 'Poziom wiedzy',
    motivations: 'Motywacje',
    weakPoints: 'Słabe punkty',
    trustLevel: 'Poziom zaufania',
    recommendedStrategy: 'Zalecana strategia',
    psychProfile: 'Profil psychologiczny',
    
    // Reports
    summary: 'Podsumowanie',
    recommendation: 'Rekomendacja',
    risks: 'Ryzyka',
    assessment: 'Ocena',
    disagrees: 'Sprzeciwia się',
    disagreementReason: 'Powód sprzeciwu',
    nextSteps: 'Kolejne kroki',
    confidence: 'Pewność',
    
    // Email
    subject: 'Temat',
    body: 'Treść',
    tone: 'Ton',
    approve: 'Zatwierdź',
    reject: 'Odrzuć',
    draft: 'Szkic',
    approved: 'Zatwierdzony',
    rejected: 'Odrzucony',
    purpose: 'Cel',
    
    // Phone
    scheduledAt: 'Zaplanowano na',
    outcome: 'Wynik',
    handoffToHuman: 'Przekaż człowiekowi',
    scheduleCall: 'Zaplanuj rozmowę',
    scheduled: 'Zaplanowana',
    completed_status: 'Zakończona',
    
    // Common
    loading: 'Ładowanie...',
    error: 'Błąd',
    success: 'Sukces',
    noData: 'Brak danych',
    back: 'Wróć',
    create: 'Utwórz',
    title: 'Tytuł',
    warnings: 'Ostrzeżenia',
    supervisorNote: 'Notatka nadzorcy',
    selectContractor: 'Wybierz kontrahenta',
  },
  en: {
    dashboard: 'Dashboard',
    contractors: 'Contractors',
    suppliers: 'Suppliers',
    admin: 'Admin',
    inbox: 'Inbox',
    negotiations: 'Negotiations',
    reports: 'Reports',
    emailDrafts: 'Emails',
    phoneCalls: 'Phone Calls',
    agentConfig: 'Agent Profile',
    agentRoles: 'Roles & Duties',
    settings: 'Settings',
    research: 'Find Contractors',
    products: 'Product Catalog',
    visualMatch: 'Visual Match',
    documents: 'Documents',
    pipeline: 'Sales Pipeline',
    strategy: 'Strategy Planner',
    merchant: 'Autonomous Merchant',
    projectAnalyzer: 'Project Analyzer',
    leadQueue: 'Lead Queue',
    offerCreator: 'Offer Creator',
    intelligence: 'Intelligence Center',
    architects: 'Architects',
    proposals: 'Proposals & Contracts',
    meetings: 'Meetings',
    recommendations: 'AI Recommendations',
    tenders: 'Tenders',
    preTender: 'Pre-Tender (signals)',
    feed: 'Adam Feed',
    subscriptions: 'Subscriptions',
    homeV3: 'Home (briefing)',
    activeNegotiations: 'Active Negotiations',
    atRiskNegotiations: 'At Risk',
    totalContractors: 'Contractors',
    avgReputation: 'Avg Reputation',
    totalReports: 'Reports',
    recentActivity: 'Recent Activity',
    addContractor: 'Add Contractor',
    name: 'Name',
    company: 'Company',
    email: 'Email',
    phone: 'Phone',
    notes: 'Notes',
    tags: 'Tags',
    reputation: 'Reputation',
    lastInteraction: 'Last Interaction',
    riskLevel: 'Risk Level',
    delete: 'Delete',
    edit: 'Edit',
    save: 'Save',
    cancel: 'Cancel',
    newNegotiation: 'New Negotiation',
    brief: 'Brief',
    channel: 'Channel',
    chat: 'Chat',
    status: 'Status',
    active: 'Active',
    completed: 'Completed',
    sendMessage: 'Send Message',
    typeMessage: 'Type counterparty message...',
    generateReport: 'Generate Report',
    generateEmail: 'Generate Email',
    agentName: 'Agent Name',
    experience: 'Experience',
    origin: 'Origin',
    defaultStyle: 'Default Style',
    superpower: 'Superpower',
    weakness: 'Weakness',
    beliefs: 'Beliefs',
    addBelief: 'Add Belief',
    language: 'Language',
    impatience: 'Impatience',
    curiosity: 'Curiosity',
    distance: 'Distance',
    satisfaction: 'Satisfaction',
    internalState: 'Internal State',
    negotiationStyle: 'Negotiation Style',
    knowledgeLevel: 'Knowledge Level',
    motivations: 'Motivations',
    weakPoints: 'Weak Points',
    trustLevel: 'Trust Level',
    recommendedStrategy: 'Recommended Strategy',
    psychProfile: 'Psychological Profile',
    summary: 'Summary',
    recommendation: 'Recommendation',
    risks: 'Risks',
    assessment: 'Assessment',
    disagrees: 'Disagrees',
    disagreementReason: 'Disagreement Reason',
    nextSteps: 'Next Steps',
    confidence: 'Confidence',
    subject: 'Subject',
    body: 'Body',
    tone: 'Tone',
    approve: 'Approve',
    reject: 'Reject',
    draft: 'Draft',
    approved: 'Approved',
    rejected: 'Rejected',
    purpose: 'Purpose',
    scheduledAt: 'Scheduled At',
    outcome: 'Outcome',
    handoffToHuman: 'Handoff to Human',
    scheduleCall: 'Schedule Call',
    scheduled: 'Scheduled',
    completed_status: 'Completed',
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    noData: 'No Data',
    back: 'Back',
    create: 'Create',
    title: 'Title',
    warnings: 'Warnings',
    supervisorNote: 'Supervisor Note',
    selectContractor: 'Select Contractor',
  }
};

export function t(key, lang = 'pl') {
  return translations[lang]?.[key] || translations['en']?.[key] || translations['pl']?.[key] || key;
}

// DE/FR/ES translations (core navigation)
translations.de = {
  dashboard: 'Dashboard', contractors: 'Auftragnehmer', negotiations: 'Verhandlungen',
  reports: 'Berichte', emailDrafts: 'E-Mails', phoneCalls: 'Anrufe',
  agentConfig: 'Agentenprofil', agentRoles: 'Rollen & Aufgaben', settings: 'Einstellungen', research: 'Auftragnehmer suchen',
  products: 'Produktkatalog', documents: 'Dokumente', pipeline: 'Vertriebspipeline', strategy: 'Strategieplaner', merchant: 'Autonomer H\u00e4ndler', projectAnalyzer: 'Projektanalyse', leadQueue: 'Lead-Warteschlange',
  save: 'Speichern', cancel: 'Abbrechen', create: 'Erstellen', delete: 'L\u00f6schen',
  loading: 'Laden...', noData: 'Keine Daten', back: 'Zur\u00fcck',
  activeNegotiations: 'Aktive Verhandlungen', totalContractors: 'Auftragnehmer',
  recentActivity: 'Letzte Aktivit\u00e4t', addContractor: 'Auftragnehmer hinzuf\u00fcgen',
  newNegotiation: 'Neue Verhandlung', generateReport: 'Bericht erstellen',
  sendMessage: 'Nachricht senden', typeMessage: 'Nachricht eingeben...',
  name: 'Name', company: 'Firma', email: 'E-Mail', phone: 'Telefon',
};

translations.fr = {
  dashboard: 'Tableau de bord', contractors: 'Contractants', negotiations: 'N\u00e9gociations',
  reports: 'Rapports', emailDrafts: 'E-mails', phoneCalls: 'Appels',
  agentConfig: "Profil de l'agent", agentRoles: "R\u00f4les et devoirs", settings: 'Param\u00e8tres', research: 'Rechercher des contractants',
  products: 'Catalogue produits', documents: 'Documents', pipeline: 'Pipeline de ventes', strategy: 'Planificateur', merchant: 'Marchand autonome', projectAnalyzer: 'Analyse de projet', leadQueue: 'File de leads',
  save: 'Enregistrer', cancel: 'Annuler', create: 'Cr\u00e9er', delete: 'Supprimer',
  loading: 'Chargement...', noData: 'Aucune donn\u00e9e', back: 'Retour',
  activeNegotiations: 'N\u00e9gociations actives', totalContractors: 'Contractants',
  recentActivity: 'Activit\u00e9 r\u00e9cente', addContractor: 'Ajouter un contractant',
  newNegotiation: 'Nouvelle n\u00e9gociation', generateReport: 'G\u00e9n\u00e9rer un rapport',
  sendMessage: 'Envoyer', typeMessage: 'Tapez le message...',
  name: 'Nom', company: 'Entreprise', email: 'E-mail', phone: 'T\u00e9l\u00e9phone',
};

translations.es = {
  dashboard: 'Panel', contractors: 'Contratistas', negotiations: 'Negociaciones',
  reports: 'Informes', emailDrafts: 'Correos', phoneCalls: 'Llamadas',
  agentConfig: 'Perfil del agente', agentRoles: 'Roles y deberes', settings: 'Configuraci\u00f3n', research: 'Buscar contratistas',
  products: 'Cat\u00e1logo de productos', documents: 'Documentos', pipeline: 'Pipeline de ventas', strategy: 'Planificador', merchant: 'Comerciante aut\u00f3nomo', projectAnalyzer: 'Analizador de proyectos', leadQueue: 'Cola de leads',
  save: 'Guardar', cancel: 'Cancelar', create: 'Crear', delete: 'Eliminar',
  loading: 'Cargando...', noData: 'Sin datos', back: 'Volver',
  activeNegotiations: 'Negociaciones activas', totalContractors: 'Contratistas',
  recentActivity: 'Actividad reciente', addContractor: 'A\u00f1adir contratista',
  newNegotiation: 'Nueva negociaci\u00f3n', generateReport: 'Generar informe',
  sendMessage: 'Enviar', typeMessage: 'Escriba el mensaje...',
  name: 'Nombre', company: 'Empresa', email: 'Correo', phone: 'Tel\u00e9fono',
};

export default translations;
